import React, { useMemo } from "react";
import MaterialIcon from "../../../shared/components/MaterialIcon";
import EnterpriseFilterSelect from "../../../shared/components/EnterpriseFilterSelect";
import { useTranslation } from "../../../i18n";
import {
  getCaseStatusFilterOptions,
  getViolationTypeFilterOptions,
} from "../../../i18n/domain/cases";

const FILTER_ROW_CLASS =
  "mb-6 grid grid-cols-[minmax(0,1.45fr)_minmax(0,1fr)_minmax(0,1fr)] items-center gap-3";

const DeletionCasesFilterBar = ({
  statusFilter,
  onStatusFilterChange,
  statusGroupFilter = "",
  violationFilter,
  onViolationFilterChange,
  search,
  onSearchChange,
  searchPlaceholder,
  variant = "default",
}) => {
  const { t } = useTranslation();

  const statusOptions = useMemo(() => getCaseStatusFilterOptions(t), [t]);
  const violationOptions = useMemo(() => getViolationTypeFilterOptions(t), [t]);

  const enterpriseStatusOptions = useMemo(
    () => [
      { value: "", label: t("cases.allStatus") },
      { value: "initiated", label: t("cases.status.pending") },
      { value: "started", label: t("cases.status.inProgress") },
      { value: "legal_action", label: t("cases.status.legal_action") },
      { value: "completed", label: t("cases.status.completed") },
      { value: "rejected", label: t("cases.status.rejected") },
    ],
    [t]
  );

  const enterpriseViolationOptions = useMemo(
    () => [
      { value: "", label: t("cases.allViolations") },
      ...violationOptions.filter((opt) => opt.value),
    ],
    [t, violationOptions]
  );

  const resolvedSearchPlaceholder =
    searchPlaceholder || t("cases.searchPlaceholder");

  const isEnterprise = variant === "enterprise";
  const resolvedStatusOptions = isEnterprise ? enterpriseStatusOptions : statusOptions;
  const resolvedViolationOptions = isEnterprise
    ? enterpriseViolationOptions
    : violationOptions;

  const wrapperClass = isEnterprise
    ? `${FILTER_ROW_CLASS} rounded-xl bg-surface-container-low p-4`
    : FILTER_ROW_CLASS;

  const searchInputClass = isEnterprise
    ? "w-full rounded-lg border-0 bg-white py-3 pl-10 pr-4 text-body-md text-on-surface ring-1 ring-outline-variant transition-all placeholder:text-on-surface-variant/70 focus:outline-none focus:ring-2 focus:ring-secondary"
    : "h-11 w-full rounded-lg border border-outline-variant/40 bg-white px-4 pl-10 text-body-md text-on-surface outline-none transition-all placeholder:text-on-surface-variant/70 focus:border-secondary focus:ring-2 focus:ring-secondary/20";

  return (
    <div className={wrapperClass}>
      <div className="relative min-w-0">
        <MaterialIcon
          name="search"
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-[20px] text-on-surface-variant"
        />
        <input
          type="search"
          placeholder={resolvedSearchPlaceholder}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className={searchInputClass}
        />
      </div>

      <div className="min-w-0">
        <EnterpriseFilterSelect
          value={statusFilter}
          onChange={onStatusFilterChange}
          options={resolvedStatusOptions}
          disabled={Boolean(statusGroupFilter)}
          minWidth="0"
          fullWidth
          ariaLabel={t("cases.filterStatus")}
        />
      </div>

      <div className="min-w-0">
        <EnterpriseFilterSelect
          value={violationFilter}
          onChange={onViolationFilterChange}
          options={resolvedViolationOptions}
          minWidth="0"
          fullWidth
          ariaLabel={t("cases.filterViolation")}
        />
      </div>
    </div>
  );
};

export default DeletionCasesFilterBar;
